import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createScenario = api(async function createScenario({ name, regimeId, rateCardId, ruleSetId, ruleSetIds }) {
    return mutate(
        gql`
            mutation CreateScenario(
                $name: String!
                $regimeId: String!
                $rateCardId: String!
                $ruleSetId: String
                $ruleSetIds: [String]
            ) {
                createScenario(
                    name: $name
                    regimeId: $regimeId
                    rateCardId: $rateCardId
                    ruleSetId: $ruleSetId
                    ruleSetIds: $ruleSetIds
                ) {
                    id
                    name
                    regimeId
                    rateCardId
                    ruleSetId
                    status
                }
            }
        `,
        { name, regimeId, rateCardId, ruleSetId: ruleSetId || null, ruleSetIds: ruleSetIds || [] },
        { returns: "createScenario" }
    )
})
